module.exports = __webpack_public_path__ + "media/images/flags/32/Liberia-64552e7f6bd10f751334406f6cd6c766.png";